import { useMutation, useQuery } from '@tanstack/react-query';
import * as service from '../services';
import { useOmnichannelStore } from '../store/ModuloOmnichannel.store';
import { OmnichannelPreferences } from '../types';

export const useOmnichannelPreferenceFilter = () => {
  const { setOmnichannelMutateRequestBody, setOmnichannelState } = useOmnichannelStore();

  const handleGetOmnichannelPreferences = async () => {
    const resp = await service.getOmnichannelPreferences();
    return resp;
  };

  const handleSaveOmnichannelPreferences = async (data: OmnichannelPreferences) => {
    const resp = await service.saveOmnichannelPreferences(data);
    return resp;
  };

  const getSuccessAction = (data: OmnichannelPreferences) => {
    const preference = data?.data;
    const newData = {
      tipoPreco: preference?.tipoPreco || 'PRECO_PAGO',
    };
    setOmnichannelState('omnichannelPreferences', newData);
    setOmnichannelMutateRequestBody('tipoPreco', newData.tipoPreco);
  };

  useQuery({
    queryKey: ['get-omnichannel-preferences'],
    queryFn: handleGetOmnichannelPreferences,
    onSuccess: getSuccessAction,
  });

  const saveMutation = useMutation({
    mutationFn: handleSaveOmnichannelPreferences,
  });

  const handleChangePriceType = (value: 'PRECO_PAGO' | 'PRECO_REGULAR') => {
    const body = {
      tipoPreco: value,
    };
    setOmnichannelState('omnichannelPreferences', body);
    setOmnichannelMutateRequestBody('tipoPreco', value);
    saveMutation.mutate(body);
  };

  return {
    preferenceSaveLoading: saveMutation.isPending,
    handleChangePriceType,
    handleGetOmnichannelPreferences,
    handleSaveOmnichannelPreferences,
  };
};
